import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import legalAssociationsHateCrimeAdvocacyItemValidator from './validators/items';
import { LegalAssociationsHateCrimeAdvocacyModel } from './types';

const legalAssociationsHateCrimeAdvocacyValidator: ValidateJSModel<LegalAssociationsHateCrimeAdvocacyModel> = {
  HasHateCrimeAdvocacy: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasHateCrimeAdvocacy?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsHateCrimeAdvocacyItemValidator },
      };
    }

    return {};
  },
};

export default legalAssociationsHateCrimeAdvocacyValidator;
